// Calendario semana BSP — IATA Paraguay
import { BspPeriodOption } from './types';

export const BSP_PERIODS_PY: BspPeriodOption[] = [
	{
		name: 'PY20260101W',
		from_date: '2026-01-01',
		to_date: '2026-01-07',
		payment_date: '2026-01-14',
		label: 'PY 20260101W 01/01 → 07/01',
	},
	{
		name: 'PY20260102W',
		from_date: '2026-01-08',
		to_date: '2026-01-14',
		payment_date: '2026-01-21',
		label: 'PY 20260102W 08/01 → 14/01',
	},
	{
		name: 'PY20260103W',
		from_date: '2026-01-15',
		to_date: '2026-01-21',
		payment_date: '2026-01-28',
		label: 'PY 20260103W 15/01 → 21/01',
	},
	{
		name: 'PY20260104W',
		from_date: '2026-01-22',
		to_date: '2026-01-31',
		payment_date: '2026-02-06',
		label: 'PY 20260104W 22/01 → 31/01',
	},

	{
		name: 'PY20260201W',
		from_date: '2026-02-01',
		to_date: '2026-02-07',
		payment_date: '2026-02-13',
		label: 'PY 20260201W 01/02 → 07/02',
	},
	{
		name: 'PY20260202W',
		from_date: '2026-02-08',
		to_date: '2026-02-14',
		payment_date: '2026-02-24',
		label: 'PY 20260202W 08/02 → 14/02',
	},
	{
		name: 'PY20260203W',
		from_date: '2026-02-15',
		to_date: '2026-02-21',
		payment_date: '2026-02-27',
		label: 'PY 20260203W 15/02 → 21/02',
	},
	{
		name: 'PY20260204W',
		from_date: '2026-02-22',
		to_date: '2026-02-28',
		payment_date: '2026-03-06',
		label: 'PY 20260204W 22/02 → 28/02',
	},

	{
		name: 'PY20260301W',
		from_date: '2026-03-01',
		to_date: '2026-03-07',
		payment_date: '2026-03-13',
		label: 'PY 20260301W 01/03 → 07/03',
	},
	{
		name: 'PY20260302W',
		from_date: '2026-03-08',
		to_date: '2026-03-14',
		payment_date: '2026-03-20',
		label: 'PY 20260302W 08/03 → 14/03',
	},
	{
		name: 'PY20260303W',
		from_date: '2026-03-15',
		to_date: '2026-03-21',
		payment_date: '2026-03-27',
		label: 'PY 20260303W 15/03 → 21/03',
	},
	{
		name: 'PY20260304W',
		from_date: '2026-03-22',
		to_date: '2026-03-31',
		payment_date: '2026-04-09',
		label: 'PY 20260304W 22/03 → 31/03',
	},

	{
		name: 'PY20260401W',
		from_date: '2026-04-01',
		to_date: '2026-04-07',
		payment_date: '2026-04-14',
		label: 'PY 20260401W 01/04 → 07/04',
	},
	{
		name: 'PY20260402W',
		from_date: '2026-04-08',
		to_date: '2026-04-14',
		payment_date: '2026-04-21',
		label: 'PY 20260402W 08/04 → 14/04',
	},
	{
		name: 'PY20260403W',
		from_date: '2026-04-15',
		to_date: '2026-04-21',
		payment_date: '2026-04-28',
		label: 'PY 20260403W 15/04 → 21/04',
	},
	{
		name: 'PY20260404W',
		from_date: '2026-04-22',
		to_date: '2026-04-30',
		payment_date: '2026-05-08',
		label: 'PY 20260404W 22/04 → 30/04',
	},

	{
		name: 'PY20260501W',
		from_date: '2026-05-01',
		to_date: '2026-05-07',
		payment_date: '2026-05-14',
		label: 'PY 20260501W 01/05 → 07/05',
	},
	{
		name: 'PY20260502W',
		from_date: '2026-05-08',
		to_date: '2026-05-14',
		payment_date: '2026-05-22',
		label: 'PY 20260502W 08/05 → 14/05',
	},
	{
		name: 'PY20260503W',
		from_date: '2026-05-15',
		to_date: '2026-05-21',
		payment_date: '2026-05-28',
		label: 'PY 20260503W 15/05 → 21/05',
	},
	{
		name: 'PY20260504W',
		from_date: '2026-05-22',
		to_date: '2026-05-31',
		payment_date: '2026-06-05',
		label: 'PY 20260504W 22/05 → 31/05',
	},

	{
		name: 'PY20260601W',
		from_date: '2026-06-01',
		to_date: '2026-06-07',
		payment_date: '2026-06-12',
		label: 'PY 20260601W 01/06 → 07/06',
	},
	{
		name: 'PY20260602W',
		from_date: '2026-06-08',
		to_date: '2026-06-14',
		payment_date: '2026-06-22',
		label: 'PY 20260602W 08/06 → 14/06',
	},
	{
		name: 'PY20260603W',
		from_date: '2026-06-15',
		to_date: '2026-06-21',
		payment_date: '2026-06-26',
		label: 'PY 20260603W 15/06 → 21/06',
	},
	{
		name: 'PY20260604W',
		from_date: '2026-06-22',
		to_date: '2026-06-30',
		payment_date: '2026-07-07',
		label: 'PY 20260604W 22/06 → 30/06',
	},

	{
		name: 'PY20260701W',
		from_date: '2026-07-01',
		to_date: '2026-07-07',
		payment_date: '2026-07-14',
		label: 'PY 20260701W 01/07 → 07/07',
	},
	{
		name: 'PY20260702W',
		from_date: '2026-07-08',
		to_date: '2026-07-14',
		payment_date: '2026-07-21',
		label: 'PY 20260702W 08/07 → 14/07',
	},
	{
		name: 'PY20260703W',
		from_date: '2026-07-15',
		to_date: '2026-07-21',
		payment_date: '2026-07-28',
		label: 'PY 20260703W 15/07 → 21/07',
	},
	{
		name: 'PY20260704W',
		from_date: '2026-07-22',
		to_date: '2026-07-31',
		payment_date: '2026-08-07',
		label: 'PY 20260704W 22/07 → 31/07',
	},

	{
		name: 'PY20260801W',
		from_date: '2026-08-01',
		to_date: '2026-08-07',
		payment_date: '2026-08-14',
		label: 'PY 20260801W 01/08 → 07/08',
	},
	{
		name: 'PY20260802W',
		from_date: '2026-08-08',
		to_date: '2026-08-14',
		payment_date: '2026-08-21',
		label: 'PY 20260802W 08/08 → 14/08',
	},
	{
		name: 'PY20260803W',
		from_date: '2026-08-15',
		to_date: '2026-08-21',
		payment_date: '2026-08-31',
		label: 'PY 20260803W 15/08 → 21/08',
	},
	{
		name: 'PY20260804W',
		from_date: '2026-08-22',
		to_date: '2026-08-31',
		payment_date: '2026-09-07',
		label: 'PY 20260804W 22/08 → 31/08',
	},

	{
		name: 'PY20260901W',
		from_date: '2026-09-01',
		to_date: '2026-09-07',
		payment_date: '2026-09-14',
		label: 'PY 20260901W 01/09 → 07/09',
	},
	{
		name: 'PY20260902W',
		from_date: '2026-09-08',
		to_date: '2026-09-14',
		payment_date: '2026-09-21',
		label: 'PY 20260902W 08/09 → 14/09',
	},
	{
		name: 'PY20260903W',
		from_date: '2026-09-15',
		to_date: '2026-09-21',
		payment_date: '2026-09-28',
		label: 'PY 20260903W 15/09 → 21/09',
	},
	{
		name: 'PY20260904W',
		from_date: '2026-09-22',
		to_date: '2026-09-30',
		payment_date: '2026-10-07',
		label: 'PY 20260904W 22/09 → 30/09',
	},

	{
		name: 'PY20261001W',
		from_date: '2026-10-01',
		to_date: '2026-10-07',
		payment_date: '2026-10-15',
		label: 'PY 20261001W 01/10 → 07/10',
	},
	{
		name: 'PY20261002W',
		from_date: '2026-10-08',
		to_date: '2026-10-14',
		payment_date: '2026-10-21',
		label: 'PY 20261002W 08/10 → 14/10',
	},
	{
		name: 'PY20261003W',
		from_date: '2026-10-15',
		to_date: '2026-10-21',
		payment_date: '2026-10-28',
		label: 'PY 20261003W 15/10 → 21/10',
	},
	{
		name: 'PY20261004W',
		from_date: '2026-10-22',
		to_date: '2026-10-31',
		payment_date: '2026-11-09',
		label: 'PY 20261004W 22/10 → 31/10',
	},

	{
		name: 'PY20261101W',
		from_date: '2026-11-01',
		to_date: '2026-11-07',
		payment_date: '2026-11-13',
		label: 'PY 20261101W 01/11 → 07/11',
	},
	{
		name: 'PY20261102W',
		from_date: '2026-11-08',
		to_date: '2026-11-14',
		payment_date: '2026-11-20',
		label: 'PY 20261102W 08/11 → 14/11',
	},
	{
		name: 'PY20261103W',
		from_date: '2026-11-15',
		to_date: '2026-11-21',
		payment_date: '2026-11-27',
		label: 'PY 20261103W 15/11 → 21/11',
	},
	{
		name: 'PY20261104W',
		from_date: '2026-11-22',
		to_date: '2026-11-30',
		payment_date: '2026-12-07',
		label: 'PY 20261104W 22/11 → 30/11',
	},

	{
		name: 'PY20261201W',
		from_date: '2026-12-01',
		to_date: '2026-12-07',
		payment_date: '2026-12-14',
		label: 'PY 20261201W 01/12 → 07/12',
	},
	{
		name: 'PY20261202W',
		from_date: '2026-12-08',
		to_date: '2026-12-14',
		payment_date: '2026-12-21',
		label: 'PY 20261202W 08/12 → 14/12',
	},
	{
		name: 'PY20261203W',
		from_date: '2026-12-15',
		to_date: '2026-12-21',
		payment_date: '2026-12-29',
		label: 'PY 20261203W 15/12 → 21/12',
	},
	{
		name: 'PY20261204W',
		from_date: '2026-12-22',
		to_date: '2026-12-31',
		payment_date: '2027-01-11',
		label: 'PY 20261204W 22/12 → 31/12',
	},
];
